import React from 'react';
import content from '../translations/content.json';

const IndustriesPage = () => {
  const industriesNav = content.header.nav.find(item => item.key === 'industries');
  const pageTitle = industriesNav ? industriesNav.label : 'Industries We Serve'; // Fallback

  return (
    <div className="container mx-auto p-8">
      <h1 className="text-3xl font-bold mb-4">{pageTitle}</h1>
      <p>{content.platform.description}</p> {/* Using a general description from content.json */}
    </div>
  );
};

export default IndustriesPage;
